import { ASTERISK_STRING } from '@/common/constants';
import {
  FilterOperationType,
  FilterType,
} from '@/components/Table/Table.constants';
import type { Filter } from '@/components/Table/Table.types';

type ObjectValue = {
  allSelected: boolean;
  selections: Nullable<string[]>;
};

export const formatStringInRangeFilter = (
  values: Nullable<ObjectValue | string[]>,
  propertyName: string
): Nullable<Filter> => {
  if (!values) return null;

  let normalizedValues: Nullable<string[]>;

  if (Array.isArray(values)) {
    normalizedValues = values;
  } else {
    if (values.allSelected) return null;
    normalizedValues = values.selections;
  }

  if (
    !normalizedValues ||
    normalizedValues.length === 0 ||
    normalizedValues.includes(ASTERISK_STRING)
  ) {
    return null;
  }

  return {
    operationType: FilterOperationType.IN_RANGE,
    propertyName,
    type: FilterType.TEXT,
    values: normalizedValues,
  };
};
